const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { saveLastVisitedVisualization } from '@/features/visualizations/utils/lastVisitedVisualizationView';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph/')({
  loader: ({
    params
  }) => saveLastVisitedVisualization(Number(params.viewId), 'nodeGraph'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});